import client from './client';

/**
 * Question Bank API
 * Backend: /api/questions  (Phase 1)
 */

export const listQuestions = (params = {}) =>
  client.get('/api/questions', { params });

export const getQuestion = (id) =>
  client.get(`/api/questions/${id}`);

export const createQuestion = (payload) =>
  client.post('/api/questions', payload);

export const updateQuestion = (id, payload) =>
  client.patch(`/api/questions/${id}`, payload);

export const deleteQuestion = (id) =>
  client.delete(`/api/questions/${id}`);
